import type { Territory, TerritoryCode } from '~/lib/territories/territories';
import type { CheckboxTreeItem } from '~/modules/artist-roster/components/CheckboxTree/types';

export function mapTerritoriesToCheckboxTreeItem(
  t: (key: string) => string,
  items: Record<string, Territory[]>,
  selected: Set<TerritoryCode>,
): CheckboxTreeItem[] {
  const treeItems = Object.entries(items).map(([region, territories]) => ({
    id: region,
    label: region,
    isVisible: true,
    isExpanded: false,
    checked: false,
    children: territories
      .map(({ code }) => ({
        id: code,
        label: t(`names.${code}`),
        isVisible: true,
        isExpanded: false,
        checked: selected.has(code),
      }))
      .sort((t1, t2) => t1.label.localeCompare(t2.label)),
  }));

  return treeItems;
}
